/* ================= RUGZI theme.js ================= */
(function () {
  "use strict";
  var R = window.RUGZI || {};

  /* ---------- helpers ---------- */
  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  }
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2400);
  }
  window.rugziToast = toast;

  /* ---------- nav blur + mobile menu ---------- */
  var nav = document.querySelector(".nav");
  window.addEventListener("scroll", function () {
    if (nav) nav.classList.toggle("scrolled", window.scrollY > 20);
    var hb = document.querySelector(".hero-media");
    if (hb) hb.style.transform = "translateY(" + window.scrollY * 0.18 + "px)";
  });
  window.rugziMenu = function (open) {
    var m = document.getElementById("mmenu");
    if (m) m.classList.toggle("show", open);
  };

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });

  /* ---------- accordions ---------- */
  window.rugziAcc = function (btn) {
    var qa = btn.parentElement, ans = qa.querySelector(".ans");
    var open = qa.classList.contains("open");
    var group = qa.closest(".acc, .faq");
    if (group) group.querySelectorAll(".qa").forEach(function (q) {
      q.classList.remove("open"); q.querySelector(".ans").style.maxHeight = null;
    });
    if (!open) { qa.classList.add("open"); ans.style.maxHeight = ans.scrollHeight + "px"; }
  };
  document.querySelectorAll(".qa.open .ans").forEach(function (a) { a.style.maxHeight = a.scrollHeight + "px"; });

  /* ---------- wishlist toggle ---------- */
  document.addEventListener("click", function (e) {
    var w = e.target.closest(".wish, .g-wish");
    if (w) {
      e.preventDefault();
      w.classList.toggle("on");
      toast(w.classList.contains("on") ? "Saved to wishlist" : "Removed from wishlist");
    }
  });

  /* ================= CART ================= */
  var overlay = document.getElementById("overlay");
  var drawer = document.getElementById("cartDrawer");

  function openCart() { if (drawer) drawer.classList.add("show"); if (overlay) overlay.classList.add("show"); }
  function closeCart() { if (drawer) drawer.classList.remove("show"); if (overlay) overlay.classList.remove("show"); }
  window.rugziOpenCart = openCart;
  window.rugziCloseCart = closeCart;

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); refreshCart(); openCart(); }
    if (e.target.closest("[data-close-cart]")) { e.preventDefault(); closeCart(); }
  });

  function renderCart(cart) {
    var body = document.getElementById("cartBody");
    var foot = document.getElementById("cartFoot");
    var countEls = document.querySelectorAll(".cart-count");
    countEls.forEach(function (c) { c.textContent = cart.item_count; });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Time to find your statement piece.</div>';
      if (foot) foot.style.display = "none";
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x120$1$2") + '" alt="">'
        : '<div class="ph"></div>';
      return '<div class="ci" data-key="' + it.key + '">' + img +
        '<div class="info"><h4>' + it.product_title + '</h4>' +
        (it.variant_title && it.variant_title !== "Default Title" ? '<div style="font-size:12px;color:var(--text2)">' + it.variant_title + '</div>' : '') +
        '<div class="cqty"><button data-cq="-1" data-key="' + it.key + '">−</button>' + it.quantity + '<button data-cq="1" data-key="' + it.key + '">+</button></div>' +
        '<div class="rm" data-rm="' + it.key + '">Remove</div></div>' +
        '<div class="price">' + money(it.final_line_price) + '</div></div>';
    }).join("");
    if (foot) {
      foot.style.display = "block";
      document.getElementById("cartTotal").textContent = money(cart.total_price);
      var goal = R.freeShip || 0;
      var bar = document.getElementById("shipBar"), msg = document.getElementById("shipMsg");
      if (bar && msg) {
        if (goal <= 0) { msg.textContent = "🚚 Free worldwide shipping included"; bar.style.width = "100%"; }
        else if (cart.total_price >= goal) { msg.textContent = "🎉 You unlocked free express shipping!"; msg.style.color = "var(--success)"; bar.style.width = "100%"; }
        else { msg.textContent = "Add " + money(goal - cart.total_price) + " more for free express shipping"; msg.style.color = "#333"; bar.style.width = (cart.total_price / goal * 100) + "%"; }
      }
    }
  }

  function refreshCart() {
    fetch(R.routes.cart + ".js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeCart(key, qty) {
    fetch(R.routes.cart_change + ".js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener("click", function (e) {
    var cq = e.target.closest("[data-cq]");
    if (cq) {
      var key = cq.getAttribute("data-key");
      var row = cq.closest(".ci");
      var current = parseInt(row.querySelector(".cqty").childNodes[1].textContent, 10);
      changeCart(key, current + parseInt(cq.getAttribute("data-cq"), 10));
    }
    var rm = e.target.closest("[data-rm]");
    if (rm) changeCart(rm.getAttribute("data-rm"), 0);
  });

  /* ---------- add to cart (works for any [data-add-to-cart] form) ---------- */
  // Applies a Shopify discount code to the session (used by bundle tiers)
  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch("/discount/" + encodeURIComponent(code), { method: "GET", credentials: "same-origin" })
      .catch(function () { /* non-fatal: cart still works without it */ });
  }
  window.rugziApplyDiscount = applyDiscount;

  function addIds(items, cb) {
    // drop anything without a usable variant id
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) { toast("This item is unavailable"); return; }
    fetch(R.routes.cart_add + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) {
        // surface Shopify's real reason instead of failing silently
        toast(res.data && res.data.description ? res.data.description : "Could not add to cart");
        return;
      }
      refreshCart(); openCart(); if (cb) cb();
    }).catch(function () { toast("Could not add to cart"); });
  }
  window.rugziAddIds = addIds;

  // Intercept ONLY the Add-to-Cart button so the native dynamic checkout
  // (Shop Pay / Buy it now) button in the same form still goes straight to checkout.
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".js-atc");
    if (!b) return;
    e.preventDefault();
    var form = b.closest("form");
    if (!form) return;
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    // if a bundle tier with a discount code is selected, apply it first
    var bundle = window.RUGZI_bundle;
    var code = bundle && bundle.code ? bundle.code : "";
    applyDiscount(code).then(function () {
      addIds([{ id: id, quantity: qty }], function () {
        toast(bundle && bundle.discount > 0 ? "Bundle added — " + bundle.discount + "% off applied" : "Added to cart");
      });
    });
  });

  /* quick add buttons (variant id in data-variant) */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-quick-add]");
    if (!b) return;
    e.preventDefault();
    addIds([{ id: b.getAttribute("data-variant"), quantity: 1 }], function () { toast("Added to cart"); });
  });

  refreshCart();

  /* ================= PRODUCT PAGE ================= */
  var pdp = document.querySelector(".pdp");
  if (pdp) initProduct(pdp);

  function initProduct(root) {
    var data = document.getElementById("ProductJSON");
    var product = data ? JSON.parse(data.textContent) : null;

    /* gallery */
    var mainImg = root.querySelector(".main-img");
    var mainImgTag = mainImg ? mainImg.querySelector("img") : null;
    root.querySelectorAll(".thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll(".thumb").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        if (mainImgTag) mainImgTag.src = t.getAttribute("data-full");
      });
    });
    if (mainImg && mainImgTag) {
      mainImg.addEventListener("mousemove", function (e) {
        var r = mainImg.getBoundingClientRect();
        mainImgTag.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
      });
      mainImg.addEventListener("mouseenter", function () { mainImg.classList.add("zoom"); });
      mainImg.addEventListener("mouseleave", function () { mainImg.classList.remove("zoom"); });
    }

    /* variant selection */
    var optionEls = root.querySelectorAll("[data-option-index]");
    function currentOptions() {
      var opts = [];
      root.querySelectorAll(".opt[data-option-index]").forEach(function (group) {
        var sel = group.querySelector(".chip.on, .sw.on");
        opts[parseInt(group.getAttribute("data-option-index"), 10)] = sel ? sel.getAttribute("data-value") : null;
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }
    function updateVariant() {
      if (!product) return;
      var v = findVariant(currentOptions());
      if (!v) return;
      var idInput = root.querySelector('[name="id"]');
      if (idInput) idInput.value = v.id;
      // swap the gallery image when the selected variant has its own photo
      if (v.featured_image && v.featured_image.src && mainImgTag) {
        var newSrc = v.featured_image.src;
        mainImgTag.src = newSrc;
        root.querySelectorAll(".thumb").forEach(function (t) {
          var full = t.getAttribute("data-full") || "";
          var base = full.split("?")[0].replace(/_\d+x\d*(\.[a-z]+)$/i, "$1");
          t.classList.toggle("active", newSrc.indexOf(base.split("/").pop().split(".")[0]) > -1);
        });
      }
      var priceEl = root.querySelector(".price");
      var cmpEl = root.querySelector(".price-compare");
      var saveEl = root.querySelector(".save");
      if (priceEl) priceEl.textContent = money(v.price);
      // Add-to-cart shows the real total the shopper will pay (bundle aware)
      var atc = root.querySelector(".js-atc-price");
      if (atc) {
        var b = window.RUGZI_bundle;
        if (b && b.qty > 1) {
          var total = Math.round(v.price * b.qty * (1 - (b.discount || 0) / 100));
          atc.textContent = money(total);
        } else {
          atc.textContent = money(v.price);
        }
      }
      var sticky = document.querySelector(".js-sticky-price");
      if (sticky) sticky.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (cmpEl) { cmpEl.textContent = money(v.compare_at_price); cmpEl.style.display = ""; }
        if (saveEl) {
          var diff = v.compare_at_price - v.price;
          var pct = Math.round(diff / v.compare_at_price * 100);
          saveEl.textContent = "You save " + money(diff) + " (" + pct + "%)";
          saveEl.style.display = "";
        }
      } else {
        if (cmpEl) cmpEl.style.display = "none";
        if (saveEl) saveEl.style.display = "none";
      }
      // Store always continues selling — never disable the button on a stale availability flag.
      var btn = root.querySelector(".js-atc");
      if (btn) { btn.disabled = false; btn.classList.remove("sold"); }
    }
    // Only bind real variant options (scoped so bundle tiers never interfere)
    root.querySelectorAll(".opt[data-option-index] .chip, .opt[data-option-index] .sw").forEach(function (chip) {
      if (chip.classList.contains("sold")) return;
      chip.addEventListener("click", function () {
        var group = chip.closest(".opt");
        group.querySelectorAll(".chip, .sw").forEach(function (x) { x.classList.remove("on"); });
        chip.classList.add("on");
        var selLabel = group.querySelector(".sel");
        if (selLabel) selLabel.textContent = chip.getAttribute("data-value");
        updateVariant();
      });
    });

    /* quantity */
    var qtyInput = root.querySelector('[name="quantity"]');
    var qtyVal = root.querySelector(".js-qty-val");
    function setQty(n) {
      n = Math.max(1, n);
      if (qtyInput) qtyInput.value = n;
      if (qtyVal) qtyVal.textContent = n;
    }
    window.rugziQty = function (d) {
      if (!qtyInput) return;
      setQty(parseInt(qtyInput.value, 10) + d);
      // manual quantity change means the shopper is off the bundle tiers
      clearBundle();
      updateVariant();
    };

    /* ---------- BUNDLE & SAVE (functional) ---------- */
    var bundleWrap = root.querySelector("[data-bundle]");
    var bundleNote = root.querySelector("[data-bundle-note]");

    function clearBundle() {
      if (!bundleWrap) return;
      bundleWrap.querySelectorAll(".bundle-tier").forEach(function (t) { t.classList.remove("on"); });
      window.RUGZI_bundle = null;
      if (bundleNote) bundleNote.textContent = "";
    }

    if (bundleWrap) {
      var tiers = bundleWrap.querySelectorAll(".bundle-tier");
      tiers.forEach(function (tier) {
        tier.addEventListener("click", function () {
          tiers.forEach(function (t) { t.classList.remove("on"); });
          tier.classList.add("on");

          var q = parseInt(tier.getAttribute("data-bundle-qty"), 10) || 1;
          var disc = parseFloat(tier.getAttribute("data-bundle-discount")) || 0;
          var code = tier.getAttribute("data-bundle-code") || "";

          setQty(q);
          window.RUGZI_bundle = { qty: q, discount: disc, code: code };
          updateVariant();

          if (bundleNote) {
            if (disc > 0) {
              var v = findVariant(currentOptions()) || (product && product.variants[0]);
              var saved = v ? Math.round(v.price * q * disc / 100) : 0;
              bundleNote.textContent = "You save " + money(saved) + " with this bundle — discount applies at checkout.";
              bundleNote.classList.add("on");
            } else {
              bundleNote.textContent = "";
              bundleNote.classList.remove("on");
            }
          }
        });
      });
      // pick up the pre-selected first tier
      var pre = bundleWrap.querySelector(".bundle-tier.on");
      if (pre) {
        window.RUGZI_bundle = {
          qty: parseInt(pre.getAttribute("data-bundle-qty"), 10) || 1,
          discount: parseFloat(pre.getAttribute("data-bundle-discount")) || 0,
          code: pre.getAttribute("data-bundle-code") || ""
        };
        setQty(window.RUGZI_bundle.qty);
      }
    }

    updateVariant();

    /* sticky ATC */
    var stick = document.querySelector(".sticky-atc");
    var anchor = root.querySelector(".buy-actions");
    if (stick && anchor) {
      new IntersectionObserver(function (e) {
        stick.classList.toggle("show", !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    /* countdown */
    var cd = root.querySelector(".countdown");
    if (cd) {
      var end = Date.now() + (4 * 3600 + 37 * 60) * 1000;
      setInterval(function () {
        var d = Math.max(0, end - Date.now());
        var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        var H = root.querySelector(".cd-h"), M = root.querySelector(".cd-m"), S = root.querySelector(".cd-s");
        if (H) H.textContent = String(h).padStart(2, "0");
        if (M) M.textContent = String(m).padStart(2, "0");
        if (S) S.textContent = String(s).padStart(2, "0");
      }, 1000);
    }
    var viewers = root.querySelector(".js-viewers");
    if (viewers) setInterval(function () { viewers.textContent = 30 + Math.floor(Math.random() * 14); }, 3200);

    /* frequently bought together */
    var fbt = document.querySelector(".fbt");
    if (fbt) {
      var base = parseInt(fbt.getAttribute("data-base") || "0", 10);
      function fbtCalc() {
        var t = base;
        fbt.querySelectorAll(".fbtChk:checked").forEach(function (c) { t += parseInt(c.getAttribute("data-price"), 10); });
        var el = document.getElementById("fbtTotal");
        if (el) el.textContent = money(t);
      }
      fbt.querySelectorAll(".fbtChk").forEach(function (c) { c.addEventListener("change", fbtCalc); });
      var addAll = fbt.querySelector(".js-fbt-add");
      if (addAll) addAll.addEventListener("click", function () {
        var items = [{ id: fbt.getAttribute("data-base-variant"), quantity: 1 }];
        fbt.querySelectorAll(".fbtChk:checked").forEach(function (c) {
          if (c.getAttribute("data-variant")) items.push({ id: c.getAttribute("data-variant"), quantity: 1 });
        });
        addIds(items, function () { toast("Bundle added 🎉"); });
      });
      fbtCalc();
    }
  }

  /* ---------- estimated delivery date range ---------- */
  document.querySelectorAll(".js-eta").forEach(function (el) {
    var opt = { month: "short", day: "numeric" };
    var d1 = new Date(Date.now() + 4 * 864e5);
    var d2 = new Date(Date.now() + 8 * 864e5);
    el.textContent = d1.toLocaleDateString(undefined, opt) + " – " + d2.toLocaleDateString(undefined, opt);
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll("[data-before-after]").forEach(function (ba) {
    var after = ba.querySelector(".ba-after");
    var handle = ba.querySelector(".ba-handle");
    var drag = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = Math.max(2, Math.min(98, (x - r.left) / r.width * 100));
      after.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
      handle.style.left = p + "%";
    }
    ba.addEventListener("mousedown", function (e) { drag = true; set(e.clientX); });
    window.addEventListener("mousemove", function (e) { if (drag) set(e.clientX); });
    window.addEventListener("mouseup", function () { drag = false; });
    ba.addEventListener("touchstart", function (e) { set(e.touches[0].clientX); }, { passive: true });
    ba.addEventListener("touchmove", function (e) { set(e.touches[0].clientX); }, { passive: true });
  });

  /* ---------- product image lightbox (fullscreen + swipe) ---------- */
  (function initLightbox() {
    var main = document.querySelector(".main-img");
    var lb = document.getElementById("lightbox");
    if (!main || !lb) return;
    var lbImg = document.getElementById("lbImg");
    var lbIndex = document.getElementById("lbIndex");
    var lbTotal = document.getElementById("lbTotal");
    var thumbs = Array.prototype.slice.call(document.querySelectorAll(".thumbs .thumb"));
    function list() {
      if (thumbs.length) return thumbs.map(function (t) { return t.getAttribute("data-full"); });
      var m = main.querySelector("img");
      return m ? [m.getAttribute("data-full") || m.src] : [];
    }
    var imgs = list();
    if (!imgs.length) return;
    var idx = 0;
    lbTotal.textContent = imgs.length;
    function show(i) { idx = (i + imgs.length) % imgs.length; lbImg.src = imgs[idx]; lbIndex.textContent = idx + 1; }
    function open(i) { imgs = list(); lbTotal.textContent = imgs.length; show(i); lb.classList.add("show"); lb.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
    function close() { lb.classList.remove("show"); lb.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    main.addEventListener("click", function (e) {
      if (e.target.closest(".g-wish, .g-badge, button")) return;
      var active = document.querySelector(".thumb.active");
      var start = active ? thumbs.indexOf(active) : 0;
      open(start < 0 ? 0 : start);
    });
    lb.querySelector(".lb-close").addEventListener("click", close);
    lb.querySelector(".lb-prev").addEventListener("click", function (e) { e.stopPropagation(); show(idx - 1); });
    lb.querySelector(".lb-next").addEventListener("click", function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb || e.target.classList.contains("lb-stage")) close(); });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("show")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") show(idx - 1);
      else if (e.key === "ArrowRight") show(idx + 1);
    });
    var sx = 0, sy = 0;
    lb.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
  })();

  /* ---------- newsletter demo submit ---------- */
  document.addEventListener("submit", function (e) {
    var f = e.target.closest(".js-news");
    if (f && f.getAttribute("data-demo") === "true") { e.preventDefault(); toast("You're in! Check your inbox for your code."); f.reset(); }
  });

  /* ---------- rotating announcement bar ---------- */
  (function () {
    var bar = document.querySelector(".ann[data-rotate]");
    if (!bar) return;
    var msgs = bar.querySelectorAll(".ann-msg");
    if (msgs.length < 2) return;
    var i = 0;
    var every = (parseInt(bar.getAttribute("data-rotate"), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove("on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("on");
    }, every);
  })();

  /* ---------- keyboard: close drawer/lightbox with Escape ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var d = document.getElementById("cartDrawer");
    if (d && d.classList.contains("show")) closeCart();
  });

  /* ---------- back to top ---------- */
  var toTop = document.getElementById("toTop");
  if (toTop) {
    window.addEventListener("scroll", function () { toTop.classList.toggle("show", window.scrollY > 600); });
    toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
  }

  /* ---------- discount popup (exit-intent + delay) ---------- */
  (function () {
    var p = document.getElementById("promoPopup");
    if (!p) return;
    var KEY = "rugzi_promo_seen";
    var DONE = "rugzi_promo_subscribed";
    var delay = parseInt(p.getAttribute("data-delay"), 10) || 0;
    var shown = false;
    function open() { if (shown) return; shown = true; p.classList.add("show"); p.setAttribute("aria-hidden", "false"); sessionStorage.setItem(KEY, "1"); }
    function close() { p.classList.remove("show"); p.setAttribute("aria-hidden", "true"); }

    // Shopify reloads the page after signup — reopen so the code is visible.
    var justSubscribed = p.querySelector(".promo-reveal") !== null;
    var hasError = p.querySelector(".promo-err") !== null;
    if (justSubscribed || hasError) {
      open();
      if (justSubscribed) { try { localStorage.setItem(DONE, "1"); } catch (e) {} }
    } else {
      // don't nag people who already subscribed, or who saw it this session
      var already = false;
      try { already = localStorage.getItem(DONE) === "1"; } catch (e) {}
      if (already || sessionStorage.getItem(KEY)) return;
      if (delay > 0) setTimeout(open, delay * 1000);
      document.addEventListener("mouseout", function (e) { if (!shown && e.clientY <= 0 && !e.relatedTarget) open(); });
    }

    p.querySelector(".promo-close").addEventListener("click", close);
    var noBtn = p.querySelector(".promo-no");
    if (noBtn) noBtn.addEventListener("click", close);
    p.addEventListener("click", function (e) { if (e.target === p) close(); });
    var codeBtn = p.querySelector(".promo-code");
    if (codeBtn) codeBtn.addEventListener("click", function () {
      var c = codeBtn.getAttribute("data-code");
      if (navigator.clipboard) navigator.clipboard.writeText(c);
      toast("Code " + c + " copied");
    });
  })();

  /* ---------- recently viewed products ---------- */
  (function () {
    var KEY = "rugzi_recent";
    function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    var pj = document.getElementById("ProductJSON");
    var current = null;
    if (pj) { try { current = JSON.parse(pj.textContent).handle; } catch (e) {} }
    if (current) {
      var a = get().filter(function (h) { return h !== current; });
      a.unshift(current);
      save(a.slice(0, 12));
    }
    var wrap = document.getElementById("recentlyViewed");
    if (!wrap) return;
    var track = wrap.querySelector(".hscroll");
    var list = get().filter(function (h) { return h !== current; }).slice(0, 8);
    if (!list.length) { wrap.style.display = "none"; return; }
    var done = 0, built = 0;
    list.forEach(function (handle) {
      fetch("/products/" + handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
        done++;
        if (pr) {
          built++;
          var img = pr.featured_image ? '<img src="' + pr.featured_image + '" alt="" loading="lazy">' : '<div class="ph">' + pr.title + "</div>";
          var price = money(pr.price);
          var cmp = pr.compare_at_price > pr.price ? "<s>" + money(pr.compare_at_price) + "</s>" : "";
          var el = document.createElement("div");
          el.className = "card";
          el.innerHTML = '<a class="card-img" href="' + pr.url + '">' + img + '</a>' +
            '<div class="card-body"><div class="stars">★★★★★</div>' +
            '<a href="' + pr.url + '"><div class="card-title">' + pr.title + '</div></a>' +
            '<div class="card-price">' + price + cmp + '</div></div>';
          track.appendChild(el);
        }
        if (done === list.length && !built) wrap.style.display = "none";
      }).catch(function () { done++; });
    });
  })();
})();
